<template>
    <v-card variant="text">
        <v-card-title class="py-5 pt-0 px-0 px-sm-1">
            <div v-if="!createMode && !editMode && !editModeOnly" class="d-flex align-center">
                <v-btn v-if="mainModeText" data-cy="create" @click="create">
                    {{ mainModeText }}
                </v-btn>
                <slot name="btn-block" />
            </div>
            <v-btn
                v-if="(createMode || editMode) && !isHideBackButton"
                class="me-3"
                size="small"
                data-cy="go-to-table-btn"
                variant="text"
                color="black"
                @click="goToTable"
            >
                <v-icon> mdi-arrow-left </v-icon>
            </v-btn>
            <span v-if="createMode">
                {{ createModeText || `${$t('create')}` }}
            </span>
            <span v-else-if="editMode">
                {{ editModeText || `${$t('edit')}` }}
            </span>
        </v-card-title>
        <v-card-text class="px-0 px-sm-1">
            <template v-if="createMode || editMode"> <slot name="additional-mode" /> </template>
            <template v-else> <slot name="main-mode" /> </template>
        </v-card-text>
    </v-card>
</template>

<script setup lang="ts">
    const props = defineProps<{
        createModeOnly?: boolean
        editModeOnly?: boolean
        mainModeText?: string
        createModeText?: string
        editModeText?: string
        isHideBackButton?: boolean
    }>()

    const emit = defineEmits<{
        (e: 'reset'): void
    }>()

    const createMode = ref<boolean>(false)
    const editMode = ref<boolean>(false)

    const goToTable = (): void => {
        createMode.value = false
        editMode.value = false
        emit('reset')
    }

    const create = (): void => {
        createMode.value = !createMode.value
    }

    const edit = (): void => {
        editMode.value = !editMode.value
    }

    defineExpose({
        create,
        edit,
        goToTable,
        editMode,
        createMode,
    })
</script>
